import { type MCPServerInfo } from '../../types';

const AtlassianRemoteServer: MCPServerInfo = {
  serverId: 'ATLASSIAN_REMOTE',
  name: 'Atlassian',
  slug: 'atlassian-remote',
  description: 'Atlassian (Remote) MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.atlassian.com/v1/mcp',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AtlassianRemoteServer;
